

/// <reference path="StockNote.ts" />

// Generated class WarehouseInputNote_ManagedObject

class WarehouseInputNote_ManagedObject extends StockNote
{
}
